export const NAMA_OPERATOR_URL = 'dashboard/nama_operator'
export const NAMA_OPERATOR_ERROR = 'NAMA_OPERATOR_ERROR'
export const NAMA_OPERATOR_LOADING = 'NAMA_OPERATOR_LOADING'
export const NAMA_OPERATOR_SUCCESS = 'NAMA_OPERATOR_SUCCESS'